var _linearGradient, _linearGradient2, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEskassa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "svg186",
    width: "2in",
    height: "2in",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 1192.246 1138.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs164"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    x1: 1422.28,
    x2: 510.213,
    y1: 309.823,
    y2: 1482.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop153",
    offset: 0,
    style: {
      stopColor: "#fbb510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop155",
    offset: 1,
    style: {
      stopColor: "#fad103"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id0",
    id: "id1",
    x1: 643.98,
    x2: 1288.51,
    y1: 1413.8,
    y2: 378.724,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    x1: 628.591,
    x2: 1365.42,
    y1: 1487.91,
    y2: 304.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop159",
    offset: 0,
    style: {
      stopColor: "#fbb510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop161",
    offset: 1,
    style: {
      stopColor: "#fbb510"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id0",
    id: "linearGradient192",
    x1: 1422.28,
    x2: 510.213,
    y1: 309.823,
    y2: 1482.7,
    gradientUnits: "userSpaceOnUse"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style151",
    type: "text/css"
  }, ".str0{stroke:#fefefe;stroke-width:12.7205}.fil1{fill:none;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-396.87 -326.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "M969 333h26c328 0 594 252 594 563s-266 563-594 563h-26c-313 0-566-252-566-563s254-563 566-563zm14 1105c-309-7-557-247-557-542s248-535 557-542c295 7 531 247 531 542s-237 535-531 542z",
    style: {
      fill: "url(#id2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "M966 370c291 0 527 236 527 527s-236 527-527 527-527-236-527-527 236-527 527-527z",
    className: "fil1 str0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fefefe",
      strokeWidth: 12.72049999
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "M966 370c291 0 527 236 527 527s-236 527-527 527-527-236-527-527 236-527 527-527z",
    style: {
      fill: "#373435"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "M966 333c311 0 563 252 563 563s-252 563-563 563-563-252-563-563 252-563 563-563z",
    className: "str0",
    style: {
      fill: "none",
      stroke: "#fefefe",
      strokeWidth: 12.72049999
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "M966 333c311 0 563 252 563 563s-252 563-563 563-563-252-563-563 252-563 563-563z",
    style: {
      fill: "url(#linearGradient192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "M966 393c278 0 503 225 503 503s-225 503-503 503-503-225-503-503 225-503 503-503z",
    style: {
      fill: "url(#id1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "M964 420c220 0 408 152 461 356h-322c-20 0-35 4-44 12s-14 20-14 37c0 14 4 24 12 31s20 10 36 10h100c42 0 71 8 89 24s26 43 26 81-10 67-30 85-52 27-96 27H791c-28 0-51-2-67-7s-31-13-46-25c-19-15-32-35-42-60-9-24-14-54-14-88 0-66 14-115 41-147 28-31 70-47 129-47h126v65H793c-27 0-48 7-62 21s-22 36-23 65h210v65H708c0 33 7 54 20 68s35 21.002 66 21c130.577-.01 241.98 0 376 0 22 0 37-3 46-10s13-17 13-32c0-16-4-27-12-33-8-7-22-10-42-10h-90c-42 0-72-9-91-26s-29-44-29-82c0-40 10-69 30-87s52-27 96-27h237c-68-132-205-222-364-222-226 0-409 183-409 409s183 409 409 409 409-183 409-409c0-21-2-42-5-62h66c3 20 4 41 4 62 0 262-212 474-474 474s-474-212-474-474 212-474 474-474z",
    className: "fil1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#deba57",
      strokeWidth: 7.06692982
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "M964 420c220 0 408 152 461 356h-322c-20 0-35 4-44 12s-14 20-14 37c0 14 4 24 12 31s20 10 36 10h100c42 0 71 8 89 24s26 43 26 81-10 67-30 85-52 27-96 27H791c-28 0-51-2-67-7s-30.957-13.054-46-25c-18.957-15.054-32.266-34.895-42-60-9.267-23.898-14-54-14-88 0-66 13.465-115.46 41-147 27.472-31.468 70-47 129-47h126v65H793c-27 0-48 7-62 21s-22 36-23 65h210v65H708c0 33 7 54 20 68s35 21 66 21h376c22 0 37-3 46-10s13-17 13-32c0-16-4.239-26.694-12-33-8.25-6.703-22-10-42-10h-90c-42 0-72-9-91-26s-29-44-29-82c0-40 10-69 30-87s52-27 96-27h237c-68-132-205-222-364-222-226 0-409 183-409 409s183 409 409 409 409-183 409-409c0-21-2-42-5-62h66c3 20 4 41 4 62 0 262-212 474-474 474s-474-212-474-474 212-474 474-474z",
    style: {
      fill: "#201e1e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEskassa);
export default __webpack_public_path__ + "static/media/eskassa.c890324e2fd5005d0d0ab1d3a99f6d6f.svg";
export { ForwardRef as ReactComponent };